(() => {
  const sections = document.querySelectorAll('.wb-row-links');

  sections.forEach((section) => {
    const track = section.querySelector('.wb-row-links__track');

    if (!track) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    const canDrag = () => {
      return window.matchMedia('(max-width: 768px)').matches && section.dataset.mobileScroll === 'true';
    };

    track.addEventListener('pointerdown', (event) => {
      if (!canDrag()) return;

      isDown = true;
      startX = event.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      track.setPointerCapture(event.pointerId);
    });

    track.addEventListener('pointermove', (event) => {
      if (!isDown || !canDrag()) return;

      const x = event.pageX - track.offsetLeft;
      const walk = x - startX;
      track.scrollLeft = scrollLeft - walk;
    });

    track.addEventListener('pointerup', (event) => {
      if (!isDown) return;

      isDown = false;

      if (track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }
    });

    track.addEventListener('pointercancel', () => {
      isDown = false;
    });
  });
})();